import type { ImgHTMLAttributes } from "react";
import { DEFAULT_PLAYER_AVATAR_SRC } from "../defaultAssets";

type DefaultAvatarFilledProps = ImgHTMLAttributes<HTMLImageElement>;

const SvgDefaultAvatarFilled = ({
  alt = "Default player avatar",
  ...props
}: DefaultAvatarFilledProps) => (
  <img
    src={DEFAULT_PLAYER_AVATAR_SRC}
    alt={alt}
    decoding="async"
    draggable={false}
    {...props}
  />
);

export default SvgDefaultAvatarFilled;
